import {AppStore} from "../desktop";
import {BaseService} from "./BaseService";
import {Service, unitTypes} from "../models/Service";
import {ServicesAPI} from "../api/ServicesAPI";
import {ServicesActionTypes} from "../store/services";
import {actionServiceFetchAllCompleted, actionServiceFetchCompleted} from "../store/services/actions";
import {actionDeleteTabForItemId, actionSetTabItem, actionSetTabStateItem} from "../store/tabs/actions";
import {ErrorService} from "./ErrorService";
import {actionToastrInfo} from "../store/global";

export default class ServicesService extends BaseService {

	static getAll() {

		let servicesAPI: ServicesAPI = new ServicesAPI()
		servicesAPI.getAll().then(ServicesService.processResponse).then(
			(data) => {
				actionServiceFetchAllCompleted(ServicesService.fromAPIServicesList(data))
			}
		).catch(error => ErrorService.handleError(error))
	}

    static getOne(service: Service) {

		let servicesAPI: ServicesAPI = new ServicesAPI()

		servicesAPI.get(service).then(ServicesService.processResponse).then(
			(data) => {
				actionServiceFetchCompleted(ServicesService.fromAPIItem(data))
			}
		).catch(error => ErrorService.handleError(error))
    }

    static save(service: Service) {

		let servicesAPI: ServicesAPI = new ServicesAPI()

		if (service.id) {
			servicesAPI.put(ServicesService.serviceToRequest(service)).then(ServicesService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: ServicesActionTypes.SAVE_COMPLETED, payload: ServicesService.fromAPIItem(data)
					})
					actionSetTabStateItem(ServicesService.fromAPIItem(data))
					actionSetTabItem(ServicesService.fromAPIItem(data))
					actionToastrInfo("Info", "Usluga je uspešno snimljena")
				}
			).catch(error => ErrorService.handleError(error))
		} else {

			servicesAPI.post(ServicesService.serviceToRequest(service)).then(ServicesService.processResponse).then(
				(data) => {
					AppStore.dispatch({
						type: ServicesActionTypes.SAVE_COMPLETED, payload: ServicesService.fromAPIItem(data)
					})
					actionSetTabStateItem(ServicesService.fromAPIItem(data))
					actionSetTabItem(ServicesService.fromAPIItem(data))
					actionToastrInfo("Info", "Usluga je uspešno snimljena")
				}
			).catch(error => ErrorService.handleError(error))

		}

	}

	static delete(service: Service) {

		let servicesAPI: ServicesAPI = new ServicesAPI()

		servicesAPI.delete(ServicesService.serviceToRequest(service)).then(ServicesService.processResponse).then(
			(data) => {
				AppStore.dispatch({
					type: ServicesActionTypes.DELETE_COMPLETED, payload: service
				})
				actionDeleteTabForItemId(service.id)
			}
		).catch(error => ErrorService.handleError(error))
	}

	static deleteServices(services: Service[]) {

		let servicesAPI: ServicesAPI = new ServicesAPI()
		let count = 0;
		services.forEach(service => {

			servicesAPI.delete(ServicesService.serviceToRequest(service)).then(ServicesService.processResponse).then(
				(data) => {
					count++;
					actionDeleteTabForItemId(service.id)
					if(count === services.length)
						AppStore.dispatch({
							type: ServicesActionTypes.DELETE_MULTIPLE_COMPLETED, payload: services
						})
				}
			).catch(error => ErrorService.handleError(error))
		});
	}

    static serviceToRequest (service: Service): any {
		let serviceRequest: any = {};

		if(service.id)
			serviceRequest.id = service.id;
		serviceRequest.name = service.title;
		serviceRequest.description = service.description;
		serviceRequest.price = service.price;
		serviceRequest.unitName = service.unitName;
		serviceRequest.invoicingType = service.invoicingType;
		serviceRequest.invoicingPeriod = service.invoicingPeriod;
		serviceRequest.categoryId = service.categoryId

		return serviceRequest
	}


	static responseToService (data: any) {
		return data
	}

	static fromAPIServicesList(apiList: any): Service[] {
        const localList = apiList.map((apiItem: any) => ServicesService.fromAPIItem(apiItem));
        //console.info('[fromAPIServicesList] converted services: ', localList);
        return localList;
    }

    static fromAPIItem(apiItem: any): Service{
        let service = new Service();

        service.id = apiItem.id;
        service.title = apiItem.name;
		service.description = apiItem.description;
		service.price = apiItem.price;
		service.unitName = apiItem.unitName;
		service.invoicingType = apiItem.invoicingType;
		service.invoicingPeriod = apiItem.invoicingPeriod;
		service.categoryId = apiItem.categoryId

        return service;
    }

    static unitForInvoice(unitType: unitTypes) {
		// let key = unitTypes[unitType as any]
		switch (unitType) {
			case unitTypes.PER_DAY:
				return "Dan"
			case unitTypes.PER_HOUR:
				return "Sat"
			case unitTypes.PER_MONTH:
				return "Mesec"
			case unitTypes.PER_PIECE:
				return "Komad"
			case unitTypes.PER_YEAR:
				return "Godina"
			default:
				return ""
		}
	}


}
